module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-or-lots/order-or-lots.component.css
// module id = ./src/app/order-or-lots/order-or-lots.component.css
// module chunks = main